/**
 * To enable the view use data-view="form". Please note that the form view needs to have is root on a form element.
 * example:
 * <form class="component" data-view="form"></form>
 */

/* Looking for a quick way to fill in the form with test data? Try this!

    $('input[type="text"]:not(#userForm\\.phoneNumber),input[type="password"]').val('test test');
    $('#userForm\\.phoneNumber,#userForm\\.accountNumber').val('1234567890');
    $('#userForm\\.email').val('test@test.com');
    $('#terms-of-use-agreement').prop('checked', 'checked');
*/

(function (ws, win) {
    'use strict';
    ws.views.threeplinboundcreatNEw = ws.views.form.extend({

        mainError: '.form-main-error',

        /**
         * Run Additional Validation On Errors
         */
        additionalValidationOnErrors: true,

        counterValue: 3000,

        /**
         * Extend generic form events
         */
        events: _.extend({}, ws.views.form.prototype.events, {
            'change input': 'resetField',
            'change #countryName': 'onCountryChange',
            'click .addPoNumber': 'addPoNumber',
            'click .deletePOValue': 'enableDeleteButton',
            'click .deletePoNumber': 'deletePONumbers',
            'click .deletePOFiles': 'deleteFiles',
            'click .deleteFileValue': 'enableDeleteButtonPOFiles',
            'change .upload': 'verifyFile',
            'keyup #notes': 'updateCounter',
            'keypress #noOfSites': 'isNumber',
            'click .resetButton': 'resetForm',
            'change .etadate': 'dateValidation',
            'click .datepicker': 'openCalender'
        }),

        /**
         * Initializes the component.
         */
        initialize() {
            ws.views.form.prototype.initialize.call(this);

            // define event aggregation
            this.$purchaseNumberList = this.$('.purchase-number-list');
            this.purchaseNumberListValues = _.template($('#threepl-po-numbers').html());
            this.$uploadFileTpl = _.template($('#threepl-po-files').html());
            this.statesListOptionsTemplate = _.template(this.$('#statesListOptionsTemplate').html());

            this.$datepicker = this.$('.datepicker');
            this.$uploadPOInput = this.$('.file-upload')[0];
            this.limitDate = $('#etaDateDifference').val() || '10';
            this.$fileName = this.$('.purchase-file-list');
            this.cqcFileTypes = 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            this.cqcExtensions = 'xls, xlsx';

            this.startDate = new Date();
            this.fileList = [];
            this.onCountryChange();
            this.lastContactDate = new Pikaday({
                field:this.$('#tbl-simple-start-date').get(0),
                format: dateFormat,
                formatStrict: true,
                minDate:new Date(),
                onSelect: function () {
                    this.hasChanged = true;
                }.bind(this)
            });
            this.updateCounter();

        },

        dateValidation() {
            $('.date-error-difference-wanrning').hide();
            var beginningDate = this.$('.etadate').val();
            var beginDateValid = globals.validateDate(beginningDate);

            var momentDate2 = moment(beginningDate, dateFormat);
            var momentDate1 = moment(new Date(), dateFormat);
            var datedifference = momentDate2.diff(momentDate1, 'days');
            var limita = parseInt(this.limitDate) - 2;

            if (datedifference < limita) {
                $('.date-error-difference-wanrning').show();
            }
        },

        openCalender() {
            $('#tbl-simple-start-date').trigger('click');
        },

        /**
         * Delete File by filtering the original filelist
         * @param {Object} e
         */
        deleteFiles: function (e) {
            this.$('.quf-file-upload-max-error').hide();
            this.$('.quf-file-upload-format-error').hide();
            var $checkboxes = this.$('.deleteFileValue');
            let poFilesList = [];
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') == true) {
                    poFilesList.push($(checkbox).data('pofilename'));
                }
            });

            $('.poFiles-list').remove();

            _.each(poFilesList, function(poFile) {
                this.fileList = _.filter(this.fileList, function (item) {
                    return item.name !== poFile;
                }.bind(this));
            }.bind(this));

            if (this.fileList.length == 0) {
                this.$('.upload')[0].value = '';
                $('.poFiles-list').remove();
                $('.deletePOFiles').attr('disabled', true);
                $('.deletePOFiles').css('background-color', '#b9bbbc');
            } else {
                this.renderFileList();
                this.enableDeleteButtonPOFiles();
            }

        },

        /**
         * Enabling the delete button
         */
        enableDeleteButtonPOFiles() {

            var $checkboxes = this.$('.deleteFileValue');
            var flag = 1;
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).is(':checked')) {
                    $('.deletePOFiles').css('background-color', '#00417a');
                    $('.deletePOFiles').attr('disabled', false);
                    flag = 0;
                }
            });

            if (flag === 1) {
                $('.deletePOFiles').attr('disabled', true);
                $('.deletePOFiles').css('background-color', '#b9bbbc');
            }
        },

        updateCounter() {
            let charsSoFar = $('#notes').val().length;
            let  remaining = this.counterValue - charsSoFar;
            $('#rem').text(remaining);
        },

        resetForm() {
            this.eventAgg.trigger('threePlclearPopUP');
        },

        /**
         * On Country Change method
         */
        onCountryChange: function () {
            this.model = new ws.models.changeState({countryIsoCode: $('#countryName').val()});

            $('#postCode').removeClass('mandatory');
            $('#postCode').removeClass('error');
            $('#postCode').parent().find('.required-error-message').hide();

            $('#state').removeClass('mandatory');
            $('#state').removeClass('error');
            $('#state').parent().find('.required-error-message').hide();

            let postalcoderequired = $('#countryName :selected').attr('data-postalcoderequired');
            let regionRequired = $('#countryName :selected').attr('data-regionRequired');
            let placeholderPostalCode = $('#countryName :selected').attr('data-postalCodeSample');
            $('#postCode').attr('placeholder', placeholderPostalCode);

            if (postalcoderequired == 'true') {
                $('#postCode').addClass('mandatory');
            }

            if (regionRequired == 'true') {
                $('#state').addClass('mandatory');
            }

            this.model.fetch().done(function (data) {
                $('#state').html(this.statesListOptionsTemplate({states:data}));
            }.bind(this)).fail(function () {
            }.bind(this));
        },

        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }

            return true;
        },

        /**
         * Verify file type
         */
        verifyFile: function () {
            var uploads = this.$('.upload')[0];
            uploads = _.toArray(uploads.files);
            this.$('.quf-file-upload-max-error').hide();
            this.$('.quf-file-upload-filename-long-error').hide();
            this.$('.quf-file-upload-format-error').hide();
            $('.addPOFiles ').removeClass('error');
            $('.poFileRequired').hide();

            // add newly selected files to proxy array
            if (uploads.length) {
                _.each(uploads, function (file) {
                    let fileName = file.name.split('.').slice(0, -1).join('.');
                    if (fileName.length < 51) {
                        if (this.cqcFileTypes.indexOf(file.type) === -1 || this.cqcExtensions.indexOf(file.name.split('.').pop().toLowerCase()) === -1) {
                            this.$('.quf-file-upload-format-error').show();
                            this.$('.upload')[0].value = '';
                        } else {
                            if (this.fileList.length < 10) {
                                this.fileList.push(file);
                            } else {
                                this.$('.quf-file-upload-max-error').show();
                            }
                        }
                    } else {
                        this.$('.quf-file-upload-filename-long-error').show();
                    }

                }.bind(this));
            }

            // remove duplicate file entries
            this.fileList = _.uniq(this.fileList, 'name');
            if (this.fileList.length > 0) {
                this.renderFileList();
                this.$('.upload')[0].value = '';
            }

        },

        /**
         * A helper to (re)render selected file list.
         */
        renderFileList: function () {
            // remove all previously rendered files and their corresponding event handlers
            this.$fileName.empty();

            //render a new file list
            this.$fileName.html(this.$uploadFileTpl({poFiles: this.fileList}));
        },

        addPoNumber(e) {
            var poNumbers = [];
            if (this.$('.poNumberAdd').val() != '') {
                poNumbers.push(this.$('.poNumberAdd').val());
            }

            $('.poNumersvALUE').each(function() {
                poNumbers.push($(this).val());
            });

            $('.ponumbers-list').remove();

            poNumbers = this.removeDuplicates(poNumbers);
            this.$('.poNumberAdd').val('');

            if (poNumbers.length >= 1) {
                $('.poNumberrequired').hide();
            }

            if (poNumbers.length > 9) {
                $('.addPoNumber').attr('disabled', true);
                $('.addPoNumber').css('background-color', '#b9bbbc');
            }

            this.$purchaseNumberList.html(this.purchaseNumberListValues({poNumbers:poNumbers}));
        },

        removeDuplicates: function (arr) {
            let uniqueArray = [];
            for (let i = 0; i < arr.length; i++) {
                if (uniqueArray.indexOf(arr[i]) == -1) {
                    uniqueArray.push(arr[i]);
                }
            }

            return uniqueArray;
        },

        /**
         * Additional validation
         */
        additionalValidation: function () {
            var poNumbers = [];

            $('.poNumersvALUE').each(function() {
                poNumbers.push($(this).val());
            });

            if (poNumbers.length == 0) {
                this.error = true;
                $('.poNumberrequired').show();
                $('.poNumberAdd').addClass('error');
            }

            if (this.fileList.length == 0) {
                this.error = true;
                $('.addPOFiles ').addClass('error');
                $('.poFileRequired').show();
            }
        },

        submitForm: function (e) {
            globals.disableApp();
            $('.custom-main-error').hide();
            var poNumbers = [];
            var poFiles = [];

            $('.poNumersvALUE').each(function() {
                poNumbers.push($(this).val());
            });

            $('.poNumberrequired').hide();
            var fd = new FormData();

            fd.append('requestType', $('#requestType').val());
            fd.append('projectId', $('#projectID').val());
            fd.append('manufacturer', $('#manufacturer').val());
            fd.append('noOfSites', $('#noOfSites').val());
            fd.append('poNumers', poNumbers);
            fd.append('unit', $('#unit').val());
            fd.append('expectedProjectDuration', $('#expectedProjectDuration').val());
            fd.append('deliveryToWestcon', $('#tbl-simple-start-date').val());
            fd.append('stockLoc', $('#stockLoc').val());

            _.each(this.fileList, function (item) {
                fd.append('poFiels', item);
            });

            fd.append('companyAddress.companyName', $('#companyName').val());
            fd.append('companyAddress.country.isocode', $('#countryName').val());
            fd.append('companyAddress.line1', $('#addressLane1').val());
            fd.append('companyAddress.line2', $('#addressLane2').val());
            fd.append('companyAddress.town', $('#city').val());
            fd.append('companyAddress.postalCode', $('#postCode').val());
            fd.append('companyAddress.state', $('#state').val());
            fd.append('notes', $('#notes').val());
            const CSRFToken = $('#CSRFToken').val();

            var submitForm = $.ajax({
                type: 'POST',
                url: globals.path.api.westcon.threePLInboudCreatNewRequestSave + '?CSRFToken=' + CSRFToken,
                data: fd,
                processData: false,
                contentType: false
            });

            submitForm.done(function (data) {
                globals.enableApp();
                if (data.error == null) {
                    this.eventAgg.trigger('threePlSuccessPopUP');
                }

                if (data.error) {
                    $('.custom-main-error').show();
                    $('.custom-main-error').html(data.errorMsg);
                }
            }.bind(this)).fail(function() {
                globals.enableApp();
            }.bind(this));

        },

        /**
         * Enabling the delete button
         */
        enableDeleteButton() {

            var $checkboxes = this.$('.deletePOValue');
            var flag = 1;
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).is(':checked')) {
                    $('.deletePoNumber').css('background-color', '#00417a');
                    $('.deletePoNumber').attr('disabled', false);
                    flag = 0;
                }
            });

            if (flag === 1) {
                $('.deletePoNumber').attr('disabled', true);
                $('.deletePoNumber').css('background-color', '#b9bbbc');
            }
        },

        deletePONumbers() {
            var $checkboxes = this.$('.deletePOValue');
            let poNumbersList = [];
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') !== true) {
                    poNumbersList.push($(checkbox).data('ponumbers'));
                }
            });

            $('.ponumbers-list').remove();

            if (poNumbersList.length < 10) {
                $('.addPoNumber').attr('disabled', false);
                $('.addPoNumber').css('background-color', '#00417a');
            }

            if (poNumbersList.length > 0) {
                this.$purchaseNumberList.html(this.purchaseNumberListValues({poNumbers:poNumbersList}));
            }

            this.enableDeleteButton();
        },

        /**
         * Reset field with error message
         */
        resetField(e) {
            var $el = $(e.target);
            $el.removeClass(this.errorClass);
            $el.nextAll(this.errorMsg).hide();
            $el.nextAll(this.customErrorMsg).hide();
            $el.parents('.controls').next('.help-inline').hide();
        },

        /**
         * Show the main error when showing all errors on the form.
         */
        hasError() {
            $(this.mainError).show();
            ws.views.form.prototype.hasError.call(this);
        },

        /**
         * Get all the elements name with error in the form
         * @returns {Array}
         */
        getFormErrorsNames() {
            // get all mandatory fields with error
            let errorsArr = $.makeArray(this.$('.mandatory:visible.error').map(function (i, el) {
                return $(el).attr('name');
            }));

            return errorsArr.length ? errorsArr : ['other'];
        },

        /**
         * Highlight input element for custom errors
         */
        highlightInputForCustomError: function (helpInlineCollection) {
            for (let item of helpInlineCollection) {
                $(item).parent().find('input').addClass(this.errorClass);
            }
        }

    });

})(westcon);
